// BioStep Component
// Screen 4: Collect headline and bio (OPTIONAL - can skip)

import React from 'react';
import { FaEdit } from 'react-icons/fa';
import styles from './BioStep.module.css';

const BioStep = ({ formData, updateFormData, onNext, onBack, onSkip, isSubmitting }) => {
  const handleChange = (field, value) => {
    updateFormData({ [field]: value });
  };

  const headlineMaxLength = 120;
  const bioMaxLength = 500;
  const bioRecommendedLength = 200;

  const headlineCharsLeft = headlineMaxLength - (formData.headline?.length || 0);
  const bioCharsLeft = bioMaxLength - (formData.bio?.length || 0);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>Tell Your Story</h2>
        <p className={styles.subtitle}>Make your profile stand out (optional)</p>
        <div className={styles.badge}>You can skip this step</div>
      </div>

      <div className={styles.content}>
        {/* Headline */}
        <div className={styles.formGroup}>
          <label className={styles.label}>
            <FaEdit /> Profile Headline
          </label>
          <input
            type="text"
            className={styles.input}
            value={formData.headline}
            onChange={(e) => handleChange('headline', e.target.value)}
            placeholder="e.g., U19 Soccer Forward | National Team | 5+ years competitive experience"
            maxLength={headlineMaxLength}
          />
          <div className={styles.charCounter}>
            {headlineCharsLeft} characters remaining
          </div>
          <p className={styles.hint}>
            💡 Tip: Include your position, level, and what makes you unique
          </p>
        </div>

        {/* Bio */}
        <div className={styles.formGroup}>
          <label className={styles.label}>
            About You
          </label>
          <textarea
            className={styles.textarea}
            value={formData.bio}
            onChange={(e) => handleChange('bio', e.target.value)}
            placeholder="Tell your story... What drives you? What are your goals? What makes you passionate about your sport?"
            rows={6}
            maxLength={bioMaxLength}
          />
          <div className={styles.charCounter}>
            {bioCharsLeft} characters remaining
            {formData.bio?.length >= bioRecommendedLength && (
              <span className={styles.checkmark}> ✓ Good length!</span>
            )}
          </div>
          <p className={styles.hint}>
            💡 Tip: Share your journey, achievements, and aspirations
          </p>
        </div>

        {/* Examples */}
        <div className={styles.examples}>
          <h4>Need inspiration?</h4>
          <ul>
            <li>"Passionate midfielder with 7 years of competitive experience..."</li>
            <li>"Started playing at age 6, made varsity team as a freshman..."</li>
            <li>"Committed to continuous improvement and team success..."</li>
          </ul>
        </div>

        {/* Buttons */}
        <div className={styles.buttons}>
          <button
            className={styles.backButton}
            onClick={onBack}
            disabled={isSubmitting}
          >
            Back
          </button>
          <button
            className={styles.skipButton}
            onClick={onSkip}
            disabled={isSubmitting}
          >
            Skip for Now
          </button>
          <button
            className={styles.nextButton}
            onClick={onNext}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Creating Profile...' : 'Finish Setup'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BioStep;















